import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from "vue";
export const SET_FILOGIX_DETAILS = "SET_FILOGIX_DETAILS";
export const SET_SYNCED_EMAILS = "SET_SYNCED_EMAILS";
export const SET_BROKERAGE_OVERRIDES = "SET_BROKERAGE_OVERRIDES";
export const SET_BROKERAGE_DATA = "SET_BROKERAGE_DATA";
export const SET_BROKERAGE_BOARDS = "SET_BROKERAGE_BOARDS";
export const SET_THEME_PREVIEW = "SET_THEME_PREVIEW";
export const SET_PERSONAL_FAQ = "SET_PERSONAL_FAQ";
export const SET_BROKERAGE_FAQ = "SET_BROKERAGE_FAQ";
export const SET_LOADING_STATE = "SET_LOADING_STATE";
export const SET_DEFAULT_EMAIL = "SET_DEFAULT_EMAIL";
export const DELETE_SYNC_EMAIL = "DELETE_SYNC_EMAIL";
export const SET_SYNCED_CALENDARS = "SET_SYNCED_CALENDARS";
export const SET_CALENDAR_SYNC = "SET_CALENDAR_SYNC";
export const SET_EXPERT_LENDER_DETAILS = "SET_EXPERT_LENDER_DETAILS";
const mutations = {
  [SET_FILOGIX_DETAILS]: (state, filogixDetails) => {
    state.filogixDetails = _objectSpread(_objectSpread({}, state.filogixDetails || {}), filogixDetails);
  },
  [SET_SYNCED_EMAILS]: (state, syncedEmails) => {
    Vue.set(state, "syncedEmails", syncedEmails);
  },
  [SET_BROKERAGE_OVERRIDES]: (state, overrides) => {
    state.overrides = _objectSpread(_objectSpread({}, state.overrides), overrides);
  },
  [SET_BROKERAGE_DATA]: (state, brokerageData) => {
    state.brokerageData = brokerageData;
  },
  [SET_BROKERAGE_BOARDS]: (state, brokerageBoards) => {
    state.brokerageBoards = brokerageBoards;
  },
  [SET_THEME_PREVIEW]: (state, {
    previewMode,
    previewModeSource
  }) => {
    state.isOnThemePreviewMode = previewMode;
    if (!previewMode) state.previewModeSource = "";else state.previewModeSource = previewModeSource;
  },
  [SET_PERSONAL_FAQ]: (state, faq) => {
    state.personalFaq = faq;
  },
  [SET_BROKERAGE_FAQ]: (state, faq) => {
    state.brokerageFaq = faq;
  },
  [SET_LOADING_STATE]: (state, loading) => {
    state.loadingState = loading;
  },
  [SET_DEFAULT_EMAIL]: (state, accountId) => {
    state.syncedEmails.emails[state.syncedEmails.defaultAccountId].defaultAccount = false;
    state.syncedEmails.defaultAccountId = accountId;
    state.syncedEmails.emails[state.syncedEmails.defaultAccountId].defaultAccount = true;
  },
  [DELETE_SYNC_EMAIL]: (state, accountId) => {
    var _context;
    state.syncedEmails.allIds = _filterInstanceProperty(_context = state.syncedEmails.allIds).call(_context, e => e !== accountId);
    Vue.delete(state.syncedEmails.emails, accountId);
    if (accountId === state.syncedEmails.defaultAccountId) {
      state.syncedEmails.defaultAccountId = "";
    }
  },
  [SET_SYNCED_CALENDARS]: (state, syncedCalendars) => {
    Vue.set(state, "syncedCalendars", syncedCalendars);
  },
  [SET_CALENDAR_SYNC]: (state, calendarId) => {
    const synced = state.syncedCalendars.calendars[calendarId].synced;
    state.syncedCalendars.calendars[calendarId].synced = !synced;
  },
  [SET_EXPERT_LENDER_DETAILS]: (state, filogixDetails) => {
    state.filogixDetails = _objectSpread(_objectSpread({}, state.filogixDetails), filogixDetails);
  }
};
export default mutations;